import { BooleanRule, ComparisonRule, MetricRule, objectsMatch } from '@iotv/datamodel';
const debug = process.env.REACT_APP_DEBUG && false;
function zip(a, b) {
    return a.map((k, i) => [k, b[i]]);
}
export var Mismatched;
(function (Mismatched) {
    Mismatched["GLOBAL"] = "Global";
    Mismatched["DESCRIPTION"] = "Description";
    Mismatched["TYPE"] = "Type";
    Mismatched["ALL"] = "Apply to all";
    Mismatched["MESSAGE_TEMPLATE"] = "Message template";
    Mismatched["ESCALATION_TEMPLATE"] = "Escalation template";
    Mismatched["DURATION_PERIOD"] = "Duration period";
    Mismatched["DURATION_UNIT"] = "Duration unit";
    Mismatched["ACTIVE"] = "Active";
    Mismatched["OPERATION"] = "Operation";
    Mismatched["BOOLEAN"] = "Boolean rules";
    Mismatched["METRIC"] = "Metric rules";
    Mismatched["COMPARISON"] = "Comparison rules";
})(Mismatched || (Mismatched = {}));
export const matching = (a, b) => {
    const mismatched = [];
    // global
    if (a.global !== b.global)
        mismatched.push(Mismatched.GLOBAL);
    debug && console.log('CompareRulesets', 'global is matching');
    // description
    if ((a.description ?? '') !== (b.description ?? ''))
        mismatched.push(Mismatched.DESCRIPTION);
    debug && console.log('CompareRulesets', 'description is matching');
    // type
    if (a.appliesToType !== b.appliesToType)
        mismatched.push(Mismatched.TYPE);
    if (a.globallyApplyToObjectTypeId !== b.globallyApplyToObjectTypeId)
        mismatched.push(Mismatched.ALL);
    debug && console.log('CompareRulesets', 'type is matching');
    // templates
    if (a.messageTemplate?.toString() !== b.messageTemplate?.toString())
        mismatched.push(Mismatched.MESSAGE_TEMPLATE);
    if (a.escalationTemplate?.toString() !== b.escalationTemplate?.toString())
        mismatched.push(Mismatched.ESCALATION_TEMPLATE);
    debug && console.log('CompareRulesets', 'templates are matching');
    // duration
    if (a.period !== b.period)
        mismatched.push(Mismatched.DURATION_PERIOD);
    if (a.unit !== b.unit)
        mismatched.push(Mismatched.DURATION_UNIT);
    debug && console.log('CompareRulesets', 'duration is matching');
    // active
    if (!objectsMatch(a.validBetween ?? {}, b.validBetween ?? {}))
        mismatched.push(Mismatched.ACTIVE);
    debug && console.log('CompareRulesets', 'active is matching');
    // operation
    if (a.setOperation !== b.setOperation)
        mismatched.push(Mismatched.OPERATION);
    debug && console.log('CompareRulesets', 'operation is matching');
    // Boolean rules
    if (a.definition.BooleanRule?.length !== b.definition.BooleanRule?.length)
        mismatched.push(Mismatched.BOOLEAN);
    debug && console.log('CompareRulesets', 'Booleans length matching');
    const booleans = zip(a.definition.BooleanRule ?? [], b.definition.BooleanRule ?? []).map(([ab, bb]) => {
        const a = new BooleanRule(ab);
        const b = new BooleanRule(bb);
        if (a.enabled !== b.enabled)
            return false;
        if (a.name !== b.name)
            return false;
        const aKey = a.key;
        const bKey = b.key;
        const aName = typeof aKey === 'object' ? aKey.name : aKey;
        const bName = typeof bKey === 'object' ? bKey.name : bKey;
        if (aName !== bName)
            return false;
        if (a.triggeringValue !== b.triggeringValue)
            return false;
        return true;
    });
    if (booleans.includes(false))
        mismatched.push(Mismatched.BOOLEAN);
    debug && console.log('CompareRulesets', 'Booleans are matching');
    // Metric rules
    if (a.definition.MetricRule?.length !== b.definition.MetricRule?.length)
        mismatched.push(Mismatched.METRIC);
    debug && console.log('CompareRulesets', 'Metrics length matching');
    const metrics = zip(a.definition.MetricRule ?? [], b.definition.MetricRule ?? []).map(([am, bm]) => {
        const a = new MetricRule(am);
        const b = new MetricRule(bm);
        debug && console.log('CompareRulesets', a, b);
        if (a.enabled !== b.enabled)
            return false;
        if (a.name !== b.name)
            return false;
        debug && console.log('CompareRulesets', a.name, 'name is matching');
        const aKey = a.key;
        const bKey = b.key;
        const aName = typeof aKey === 'object' ? aKey.name : aKey;
        const bName = typeof bKey === 'object' ? bKey.name : bKey;
        if (aName !== bName)
            return false;
        debug && console.log('CompareRulesets', a.name, 'key is matching');
        if (a.max.value !== b.max.value)
            return false;
        if (b.min.value !== b.min.value)
            return false;
        if (b.stdDev.value !== b.stdDev.value)
            return false;
        debug && console.log('CompareRulesets', a.name, 'is matching');
        return true;
    });
    if (metrics.includes(false))
        mismatched.push(Mismatched.METRIC);
    debug && console.log('CompareRulesets', 'Metrics are matching');
    // Comparison rules
    if (a.definition.ComparisonRule?.length !== b.definition.ComparisonRule?.length)
        mismatched.push(Mismatched.COMPARISON);
    debug && console.log('CompareRulesets', 'Comparisons length matching');
    const comparisons = zip(a.definition.ComparisonRule ?? [], b.definition.ComparisonRule ?? []).map(([ac, bc]) => {
        const a = new ComparisonRule(ac);
        const b = new ComparisonRule(bc);
        debug && console.log('CompareRulesets', a, b);
        if (a.enabled !== b.enabled)
            return false;
        if (a.name !== b.name)
            return false;
        debug && console.log('CompareRulesets', a.name, 'name is matching');
        const aKey = a.key;
        const bKey = b.key;
        const aName = typeof aKey === 'object' ? aKey.name : aKey;
        const bName = typeof bKey === 'object' ? bKey.name : bKey;
        if (aName !== bName)
            return false;
        debug && console.log('CompareRulesets', a.name, 'key is matching');
        if (a.triggeringKey !== b.triggeringKey)
            return false;
        debug && console.log('CompareRulesets', a.name, 'is matching');
        return true;
    });
    if (comparisons.includes(false))
        mismatched.push(Mismatched.COMPARISON);
    debug && console.log('CompareRulesets', 'Comparisons are matching');
    return [...new Set(mismatched)];
};
